module.exports = require('./lib/reset')



//////////////////
// WEBPACK FOOTER
// ./~/glamor/reset.js
// module id = 698
// module chunks = 114276838955818